module.exports = __webpack_public_path__ + "static/media/techHelp.0f4f53ae.svg";